import { useParams } from 'react-router-dom'
import { ChatView } from '../ChatView/ChatView.tsx'

/** `/audits/:auditId/chat` — the inbox the brain polls (§9.6). */
export function ChatPage() {
  const { auditId } = useParams<{ auditId: string }>()
  if (!auditId) return null
  return <ChatView auditId={auditId} />
}
